import api from './api';

/**
 * Get left-panel menu tree for the given profile (from OperationMst + RoleOperationMatrix).
 * @param {string} profileCode - Profile/role code (e.g. CRA, PM, SRM, ADMIN). From user.profileCode or user.vUserTypeCode.
 * @returns {Promise<Array>} Array of menu sections (each with operationName, operationPath, children).
 */
const getMenuForProfile = async (profileCode) => {
  if (!profileCode) {
    return [];
  }
  const response = await api.get('/operations/menu', {
    params: { profileCode: profileCode.trim() },
  });
  return response.data || [];
};

/**
 * Report hub tiles allowed for the profile (OperationMst 0613–0618 + RoleOperationMatrix).
 * @param {string} profileCode
 * @returns {Promise<Array>}
 */
const getReportsForProfile = async (profileCode) => {
  if (!profileCode) {
    return [];
  }
  const response = await api.get('/operations/reports', {
    params: { profileCode: profileCode.trim() },
  });
  return response.data || [];
};

const operationService = {
  getMenuForProfile,
  getReportsForProfile,
};

export default operationService;
